'use client';

import { useEffect, useRef, type RefObject } from 'react';
import styles from './home-live.module.css';

// A changed digit is a new element (see the key below). Child effects run
// before the parent's, so digits of the first render find `ready` still false.
function Digit({ ch, ready }: { ch: string; ready: RefObject<boolean> }) {
  const ref = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    if (ready.current) ref.current?.classList.add(styles.bump);
  }, [ready]);
  return <span ref={ref}>{ch}</span>;
}

/** Plain digits; a digit that changes fades up into place. */
/** `null` while the number is not known yet: a dash. */
export function Odometer({ value, locale }: { value: number | null; locale: string }) {
  const ready = useRef(false);
  useEffect(() => {
    ready.current = true;
  }, []);
  const str = value === null ? '–' : new Intl.NumberFormat(locale).format(Math.round(value));
  return (
    <span className={styles.odo}>
      {[...str].map((ch, i) => (
        <Digit key={`${i}-${ch}`} ch={ch} ready={ready} />
      ))}
    </span>
  );
}
